<template>
  <div class="p-5 bg-vice-teal-50 shadow overflow-hidden sm:rounded-lg border border-gray-200">
    <!-- Header -->
    <div class="inline-flex items-center gap-2">
      <BookOpenIcon class="w-7 h-7 text-vice-teal-600" />
      <span class="inline-flex font-semibold justify-start">Course materials</span>
    </div>

    <!-- Body -->
    <div class="flex text-xs flex-col gap-3">
      <!-- Sessions -->
      <div class="gap-3 w-full inline-flex justify-between items-center">
        <span class="flex my-1 text-gray-500">
          Access recordings, slides, PDFs and resources for each week
        </span>
      </div>

      <!-- Enter course button -->
      <div class="flex flex-col">
        <ViceButton
          data-cy="enter-course"
          :href="route('course.showLearningCourse', this.$page.props.course.slug)"
          target="_blank"
          @click="console.log('enter course')"
          class="w-full bg-vice-teal-600"
        >
          <span class="text-white font-semibold">Enter course</span>
          <ChevronRightIcon class="w-6 h-5" />
        </ViceButton>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/solid';
import { BookOpenIcon } from '@heroicons/vue/outline';
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  name: 'EnterCourseBox',
  components: {
    ChevronRightIcon,
    BookOpenIcon,
    ViceButton,
  },
};
</script>

<style scoped></style>
